/***
 * Copyright (c) Myia 2023-2025 - All Rights Reserved
 */
import { Bot } from 'lucide-react';

export const EmptyState = () => {
    return (
        <div className="flex items-center justify-center h-full text-muted-foreground">
            <div className="text-center">
                <Bot className="h-12 w-12 mx-auto mb-4 opacity-50" />
                <p>Start a conversation with the Code Agent</p>
                <p className="text-sm mt-1">Describe what you want to build and I'll generate the code for you.</p>
            </div>
        </div>
    );
};
